import React from 'react';

import {withStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { MdViewModule } from '@react-icons/all-files/md/MdViewModule';
import { MdViewList } from '@react-icons/all-files/md/MdViewList';
import { WayToViewConsumer } from '../contexts/wayToViewList';

const ColorButton = withStyles((theme) => ({
  root: {
    '&:hover': {
      backgroundColor: '#1fa26514',
    },
    '& svg' : {
      color: '#82d2aa',
    },
    
  }
}))(IconButton);

const SelectViewCourseList = () => {
 return (
  <WayToViewConsumer>
    {({actions}) => (
      <div className="list-btn-wrapper">
      <ColorButton color="primary" aria-label="add to shopping cart" onClick={() => actions.setViewList('grid-view')}>
        <MdViewModule />
      </ColorButton>
      <ColorButton aria-label="add to shopping cart" onClick={() => actions.setViewList('list-view')}>
        <MdViewList />
      </ColorButton>
    </div>
    )}
  </WayToViewConsumer>
 ) 
}

export default SelectViewCourseList;